import Loading from "components/Common/Loading";
import PowerBIReport from "components/Common/PowerBIReport";
import React, { useState, useEffect } from "react";
import powerBiService from "services/PowerBiService";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { SendaCustomSwal } from "components/Common/SendaCustomSwal";

const DashboardPowerBI = () => {
	const [loading, setIsLoading] = useState(false);
	const [parametros, setParametros] = useState();

	const { id } = useParams();

	const getParametros = async () => {
		setParametros(await powerBiService.getParametros(id));
	};

	const obterDados = async () => {
		try {
			setIsLoading(true);
			await Promise.all([getParametros()]);
			setIsLoading(false);
		} catch (e) {
			SendaCustomSwal.fire({
				iconHtml: '<i class="error-icon"></i>',
				title: "Oops...",
				text: "Falha ao buscar os itens ou relatório não encontrado!",
				customClass: {
					confirmButton: "custom-confirm-button",
				},
			});
		} finally {
			setIsLoading(false);
		}
	};

	useEffect(() => {
		obterDados();
	}, []);

	return (
		<Loading isLoading={loading}>
			<div className="page-content">
				<div>
					{parametros && (
						<PowerBIReport
							accessToken={parametros?.accessToken}
							embedUrl={parametros?.embedUrl}
							embedReportId={parametros?.embedReportId}
						/>
					)}
				</div>
			</div>
		</Loading>
	);
};

export default DashboardPowerBI;
